import COLORS from './colors';

export const siteDefaultFilters = {
  archived: false,
};

export const sitesMapConfig = {
  color: COLORS.DARK_GREY_02,
  isFilled: true,
  paths: [],
};

export const SITE_FORMIK_KEYS = {
  siteSurfaceImages: 'siteSurfaceImages',
  surfaceImages: 'surfaceImages',
  site: 'site',
  surfaceId: 'surfaceId',
};
